import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import GeneralInfoWithThumbnail from '../../../components/GeneralInfoWithThumbnail'
import { _ } from '../../../utils/localization'
import { canLoadMoreSelector, loadMore } from '../../attendees/attendeesSlice'
import LoadMore from '../../../components/LoadMore'
import getMugshotSrc from '../../../utils/getMugshotSrc'
import openBusinessCard from '../../profile/openBusinessCard'
import { User } from '../../auth/types'
import StyledIcon from '../../../components/Icon'
import colors from '../../../constants/colors'
import formatJobInfo from '../../../utils/formatJobInfo'
import useFetchAttendees from '../../attendees/useFetchAttendees'

const S = {
    Actions: styled.div`
        display: flex;
    `,
    SquareIcon: styled.div<{color: string}>`
        width: 18px;
        height: 18px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${({ color }) => color};
        border-radius: 3px;
    `
}

const RequestToJoinList = ({ attendeeIds, replyToRequest }
: {attendeeIds: number[], replyToRequest: (attendeeId, accepted) => void}) => {
    const dispatch = useDispatch()
    const canLoadMore = useSelector(canLoadMoreSelector())
    const attendees = useFetchAttendees(attendeeIds)

    return (
        <div style={{ padding: '0 8px' }}>
            {
                attendees.map((attendee) => (
                    <GeneralInfoWithThumbnail
                        image={getMugshotSrc(attendee)}
                        onClick={() => dispatch(openBusinessCard(attendee as User))}
                        name={`${attendee.first_name} ${attendee.last_name}`}
                        description={formatJobInfo(attendee.jobtitle, attendee.company)}
                        noBorder
                        size="sm"
                        key={attendee.id}
                    >
                        <S.Actions>
                            <S.SquareIcon
                                color={colors.regentGray}
                                onClick={() => replyToRequest(attendee.id, false)}
                            >
                                <StyledIcon icon="close" color="white" size={18} style={{ marginBottom: 3 }} />
                            </S.SquareIcon>
                            <S.SquareIcon
                                color={colors.success}
                                onClick={() => replyToRequest(attendee.id, true)}
                            >
                                <StyledIcon icon="check" color="white" size={18} style={{ marginBottom: 3 }} />
                            </S.SquareIcon>
                        </S.Actions>
                    </GeneralInfoWithThumbnail>
                ))
            }
            {canLoadMore
            && (
                <LoadMore onClick={() => dispatch(loadMore())}>
                    {_('networking.sidebar.load_more_attendees')}
                </LoadMore>
            )}
        </div>
    )
}

export default RequestToJoinList
